import axios from './axiosInstance'
import constants from '../constants'

export default function init() {
  console.log('chat builder init')
}

export async function add(post, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/vcb/builders`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.post(URL, post, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      localStorage.removeItem('ccPreviewBuilderId')
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function update(id, post, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/vcb/builders/${id}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.put(URL, post, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function get(id, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/vcb/builders/${id}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function list(app, type) {
  const URL = `${constants.customerDomain}apps/${app.id}/vcb/builders${type ? `?type=${type}` : ''}`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function reset(id, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/vcb/builders/${id}/settings`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.delete(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json;charset=UTF-8',
        },
      })
      return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function getTemporaryBuilder(builderId) {
  const URL = `${constants.chatBuilderPublicApiUrl}/builders/${builderId}`
  if (!builderId) {
    throw new Error('builderId is required.')
  }

  try {
    const response = await axios.get(URL)
    return response.data.data
  } catch (error) {
    console.error('Error fetching temporary builder:', error.response?.data || error.message)
    throw error
  }
}
